// extracted by mini-css-extract-plugin
export default {"ProcessList":"ProcessList_ProcessList__eN50P"};